import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Crown, Lock, BadgeCheck, Users } from "lucide-react";
import { api } from "@/lib/api";

const FALLBACK = "https://images.unsplash.com/photo-1760512992083-8e3ab2671ef7";

export default function Creators() {
  const [creators, setCreators] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/creators").then((r) => setCreators(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="p-6 md:p-12 max-w-5xl mx-auto">
      <div className="overline mb-1">Exclusive content</div>
      <h2 className="font-heading text-3xl md:text-4xl mb-2">Creators</h2>
      <p className="text-sm text-[#A0A0A0] mb-8">Subscribe to unlock private photos & videos from Empire creators worldwide.</p>

      {loading ? (
        <div className="text-[#A0A0A0]">Loading creators…</div>
      ) : creators.length === 0 ? (
        <div className="pe-card rounded-3xl p-10 text-center">
          <Crown className="text-[#D4AF37] mx-auto mb-4" size={40} />
          <h3 className="font-heading text-2xl mb-2">No active creators yet</h3>
          <p className="text-sm text-[#A0A0A0]">Become the first — enable Creator mode in your profile.</p>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {creators.map((c, i) => (
            <motion.div key={c.id} initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.06 }}
              data-testid={`creator-${c.id}`} onClick={() => navigate(`/creator/${c.id}`)}
              className="pe-card rounded-2xl overflow-hidden cursor-pointer">
              <div className="h-48 overflow-hidden relative">
                <img src={c.photos?.[0] || FALLBACK} alt={c.name} className="w-full h-full object-cover" />
                <div className="absolute inset-0" style={{ background: "linear-gradient(to top, rgba(0,0,0,0.85), transparent 60%)" }} />
                <span className="absolute top-3 right-3 text-xs px-3 py-1 rounded-full gold-gradient text-black font-medium flex items-center gap-1">
                  <Crown size={12} /> Creator
                </span>
                <div className="absolute bottom-3 left-4">
                  <div className="font-heading text-2xl text-white flex items-center gap-1">
                    {c.name} {c.verified && <BadgeCheck size={18} className="text-[#D4AF37]" data-testid="verified-badge" />}
                  </div>
                  <div className="text-xs text-[#A0A0A0]">{c.location || "Worldwide"}</div>
                </div>
              </div>
              <div className="p-4 flex items-center justify-between">
                <span className="text-sm text-[#A0A0A0] flex items-center gap-3">
                  <span className="flex items-center gap-1"><Lock size={14} /> {c.post_count}</span>
                  <span className="flex items-center gap-1"><Users size={14} /> {c.subscriber_count}</span>
                </span>
                <span className="text-sm font-semibold gold-text">
                  {c.subscribed ? "Subscribed" : `$${Number(c.subscription_price || 0).toFixed(2)}/mo`}
                </span>
              </div>
            </motion.div>
          ))}
        </div>
      )}
    </div>
  );
}
